class Settings {
  set(settings) {
    Object.keys(settings || {}).forEach((name) => {
      this[name] = settings[name]
    })
  }
}

export default new Settings()
